// test2389
(2389 && 0);
